<template>
  <div class="article-title-header-base">
    <div class="line-top">
      <svg
        :width="upperLine.width"
        :height="upperLine.height"
        :viewBox="`0, 0, ${upperLine.width}, ${upperLine.height}`"
        xmlns="http://www.w3.org/2000/svg">
        <circle
          v-for="(par, index) in upperLine.list"
          :key="index"
          :cx="par.cx"
          :cy="par.cy"
          :r="par.r"
          :fill="par.fill" />
      </svg>
    </div>

    <div class="article-title">{{ articleTitleMod }}</div>
    <div class="play-icon"
      v-if="hasVoice"
      @click="onPlayIconClick"
    ><img src="/static/img/yearluck/y2020/player/playIcon.svg" /></div>
    <voice-player
      ref="voiceplayer"
      :voicefile-receive="voiceData"
    ></voice-player>

    <div class="line-bottom">
      <svg
        :width="lowerLine.width"
        :height="lowerLine.height"
        :viewBox="`0, 0, ${lowerLine.width}, ${lowerLine.height}`"
        xmlns="http://www.w3.org/2000/svg">
        <circle
          v-for="(par, index) in lowerLine.list"
          :key="index"
          :cx="par.cx"
          :cy="par.cy"
          :r="par.r"
          :fill="par.fill" />
      </svg>
    </div>
  </div>
</template>

<script>
import Colors from '@/utvStore/components/YearLuck/y2020/constants/colors'
import VoicePlayer from  '@/utvStore/components/YearLuck/y2020/partials/voicePlayer'

const LINE_PARTICLE_SIZE = 3

export default {
  name: "ArticleCardHeader",
  components: { VoicePlayer },
  data() {
    return {
      upperLine: {
        list: [],
        width: 0,
        height: 0,
      },
      lowerLine: {
        list: [],
        width: 0,
        height: 0,
      }
    }
  },
  props: {
    articleTitle: {
      type: String,
      default() {
        return ''
      }
    },
    targetId: {
      type: Number,
      default() {
        return 0
      }
    },
    voiceData: {
      type: String,
      default(){
        return ''
      }
    },
    hasVoice: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  computed: {
    articleTitleMod() {
      let rtn = this.articleTitle
      if(rtn.length === 2) rtn = `${rtn.substr(0,1)} ${rtn.substr(1,1)}`
      return rtn
    }
  },
  mounted() {
    this.calc()
  },
  methods: {
    calc() {
      const bw = this.$el.clientWidth
      let sep, tw, w, scl, flg

      w = LINE_PARTICLE_SIZE
      sep = parseInt(bw/w) - 1
      sep = sep/2 > 0 ? sep : sep - 1
      tw = w * sep + w
      scl = bw / tw
      flg = false

      for(let i = 0; i < sep; i++ ){
        if((i % 2) > 0) {
          let fill_u = Colors.color.basecolor
          let fill_l = Colors.color.basecolor
          if(flg) {
            const collist = Colors.getItemColor(this.targetId)
            if( collist != null ) {
              fill_u = collist[Math.floor(Math.random() * collist.length)]
              fill_l = collist[Math.floor(Math.random() * collist.length)]
            }
            flg = false
          }else {
            flg = true
          }

          this.upperLine.width = bw
          this.upperLine.height = Math.ceil(w / scl)
          this.upperLine.list.push({
            cx: (i * w * scl) + (w / 2),
            cy: w / 2,
            r: w * scl / 2,
            fill: fill_u
          })

          this.lowerLine.width = bw
          this.lowerLine.height = Math.ceil(w / scl)
          this.lowerLine.list.push({
            cx: (i * w * scl) + (w / 2),
            cy: w / 2,
            r: w * scl / 2,
            fill: fill_l
          })
        }
      }
    },
    onPlayIconClick() {
      this.$refs.voiceplayer.playVoice()
    },
  }
}</script>

<style scoped lang="scss">
@import "../../../../../../sass/variables/index";
.article-title-header-base {
  width: 100%;
  color: $gray-20;
  margin-bottom: 10px;
  position: relative;
  .play-icon {
    display: inline-block;
    line-height: 1;
    position: absolute;
    height: 28px;
    top: 9px;
    right: 8px;
    margin: auto;
    user-select: none;
    cursor: pointer;
  }

  .article-title {
    line-height: 1;
    width: 100%;
    text-align: center;
    font-weight: bold;
    font-size: 13px;
    letter-spacing: 1px;
    padding: 12px 0;
    @include mq('w320') {
      font-size: 15px;
    }
  }
  .line-top,
  .line-bottom {
    width: 100%;
    height: 4px;
    svg {
      display: block;
      vertical-align: top;
    }
  }

}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2020/partials/articleCardHeader.vue